import { CacheHeader, DeleteHeader, PPHeader, PPUnAuthHeader } from '../common'
const URL = process.env.REACT_APP_API_ACCOUNT!

interface typePwReset {
  userId: string,
  companyName: string,
  name: string,
}

//001 ユーザー認証
export const getAuth = async (userid: string, password: string) => {
  const params = new URLSearchParams()
  params.set('userid', userid)
  params.set('pw', password)
  const header = CacheHeader()
  const res = await fetch(`${URL}/account?${params.toString()}`, header).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response.json()
    }
  })
  return res
}

//002 パスワード変更
export const changePassword = async (userid: string, token: string, role: string, password: string, currentpassword: string) => {
  const jsondata = JSON.stringify({ "password": password, "currentPassword": currentpassword })
  const header = PPHeader(userid, token, role, jsondata, 'PUT')
  const res = await fetch(`${URL}/account/${userid}`, header).then(response => {
    if (response.ok || response.status === 400) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//029 ログアウト
export const getLogout = async (userid: string, token: string, role: string): Promise<boolean> => {
  const header = DeleteHeader(userid, token, role)
  const res = await fetch(`${URL}/logout/${userid}/${token}`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else {
      throw response
    }
  })
  return res
}

//046 パスワードリセット
export const putPwReset = async (form: typePwReset) => {
  let jsondata = JSON.stringify(form)
  const header = PPUnAuthHeader(jsondata, 'PUT')
  const res = await fetch(`${URL}/pwresetreq`, header).then(response => {
    if (response.ok) {
      return response.status
    } else {
      throw response
    }
  })
  return res
}